function getScrollWidth() {
  if (typeof window === "undefined" || typeof document === "undefined") return 0;
  var paddingRight = parseInt(window.getComputedStyle(document.body).paddingRight, 10);
  var scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
  return paddingRight + scrollbarWidth;
}
export { getScrollWidth };